import { type Themes } from "@/schemas/styling/theme";

export const themes: Themes = {
  morning: {
    bg: ["#FFFFF0", "#E6F3FF"],
    backgroundColor: "#F9FAFB",
    borderColor: "#E5E7EB",
    progressBarFilledColorStageOne: "#006b94", // lighter than Kai logo's blue
    progressBarFilledColorStageTwo: "#005294", // this is the color picked from Kai logo's blue
    progressBarUnfilledColor: "#C0C0C0",
    button: {
      color: {
        primary: "#01579b",
        secondary: "#EEE",
      },
      textColor: {
        primary: "#FFF",
        secondary: "#000",
      },
    },
    text: "#1E40AF",
    subtext: "#0369A1",
    link: "#2563EB",
    icon: {
      size: {
        web: {
          large: 24,
          medium: 20,
          small: 16,
        },
        mobile: {
          large: 24,
          medium: 20,
          small: 16,
        },
      },
      color: "#111827",
    },
    typography: {
      h1: {
        size: { web: 23, mobile: 22 },
        weight: "700",
        lineHeight: 1.2,
        color: "#111827",
      },
      h2: {
        size: { web: 19, mobile: 18 },
        weight: "600",
        lineHeight: 1.3,
        color: "#333333",
      },
      h3: {
        size: { web: 16, mobile: 13 },
        weight: "500",
        lineHeight: 1.4,
        color: "#111827",
      },
      h4: {
        size: { web: 13, mobile: 11 },
        weight: "400",
        lineHeight: 1.4,
        color: "#111827",
      },
      body: {
        size: { web: 14, mobile: 13 },
        weight: "400",
        lineHeight: 1.5,
        color: "#111827",
      },
      bodySmall: {
        size: { web: 10, mobile: 10 },
        weight: "400",
        lineHeight: 1.5,
        color: "#111827",
      },
      caption: {
        size: { web: 12, mobile: 12 },
        weight: "400",
        lineHeight: 1.4,
        color: "#111827",
      },
    },
  },
};
